interface Props {
  children: React.ReactNode
}

const HeaderRow = ({ children }: Props) => (
  <tr className="uppercase text-neutral-400 text-sm font-medium">{children}</tr>
)

export default HeaderRow
